export type AwardColor = {
  bg: string;
  fg: string;
};

export const AWARD_RANK_TO_COLOR: Record<number, AwardColor> = {
  0: { bg: "#e9e9e9", fg: "#000000" }, // NOT_TRACKING
  203: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_3
  206: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_6
  209: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_9
  212: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_12
  215: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_15
  218: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_18
  221: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_21
  223: { bg: "#e9e9e9", fg: "#000000" }, // PERCENT_23
  305: { bg: "#a0e7e2", fg: "#000000" }, // SILVER_SPONSOR
  310: { bg: "#800091", fg: "#ffffff" }, // SILVER_PRODUCER
  320: { bg: "#ffdb4d", fg: "#000000" }, // GOLD_PRODUCER
  330: { bg: "#474748", fg: "#ffffff" }, // PLATINUM
  340: { bg: "#474748", fg: "#ffffff" }, // RUBY
  342: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_PLATINUM
  345: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_RUBY
  350: { bg: "#474748", fg: "#ffffff" }, // PEARL
  365: { bg: "#474748", fg: "#ffffff" }, // SAPPHIRE
  367: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_SAPPHIRE
  370: { bg: "#474748", fg: "#ffffff" }, // EMERALD
  375: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_EMERALD
  380: { bg: "#474748", fg: "#ffffff" }, // DIAMOND
  385: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_DIAMOND
  390: { bg: "#474748", fg: "#ffffff" }, // EXECUTIVE_DIAMOND
  395: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_EXECUTIVE_DIAMOND
  400: { bg: "#474748", fg: "#ffffff" }, // DOUBLE_DIAMOND
  405: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_DOUBLE_DIAMOND
  410: { bg: "#474748", fg: "#ffffff" }, // TRIPLE_DIAMOND
  415: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_TRIPLE_DIAMOND
  420: { bg: "#474748", fg: "#ffffff" }, // CROWN
  425: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_CROWN
  430: { bg: "#474748", fg: "#ffffff" }, // CROWN_AMBASSADOR
  435: { bg: "#474748", fg: "#ffffff" }, // FOUNDERS_CROWN_AMBASSADOR
  2020: { bg: "#474748", fg: "#ffffff" }, // PLATINUM_OR_ABOVE
  2022: { bg: "#e9e9e9", fg: "#000000" }, // ASSOCIATE
  2026: { bg: "#e9e9e9", fg: "#000000" }, // NOT_AVAILABLE
};
